// main.js (Vue 2.6 项目入口文件)
import Vue from 'vue'


// 注册全局自定义指令 v-single-click
Vue.directive('single-click', {
  // 指令绑定到元素上时触发（Vue 2 中是 bind 钩子，inserted 是元素插入DOM时）
  inserted(el, binding) {
    // 记录鼠标按下的时间戳
    let pressStartTime = 0
    // 长按阈值（300ms 为通用标准，可自定义）
    const LONG_PRESS_THRESHOLD = 300

    // 鼠标按下事件处理
    const handleMouseDown = (e) => {
      // 仅处理鼠标左键（e.button === 0 代表左键）
      if (e.button === 0) {
        pressStartTime = Date.now()
      }
    }

    // 鼠标抬起事件处理
    const handleMouseUp = (e) => {
      // 非左键直接返回
      if (e.button !== 0) return
      // 计算按下时长
      const pressDuration = Date.now() - pressStartTime
      // 只有时长小于阈值，才执行绑定的方法
      if (pressDuration < LONG_PRESS_THRESHOLD) {
        // 确保绑定的是函数且执行
        typeof binding.value === 'function' && binding.value()
      }
      // 重置按下时间
      pressStartTime = 0
    }

    // 鼠标移出元素时重置（避免按下后移出再抬起触发）
    const handleMouseLeave = () => {
      pressStartTime = 0
    }

    // 给元素绑定事件
    el.addEventListener('mousedown', handleMouseDown)
    el.addEventListener('mouseup', handleMouseUp)
    el.addEventListener('mouseleave', handleMouseLeave)

    // 存储事件处理函数，方便解绑（避免内存泄漏）
    el.__singleClickHandlers = [handleMouseDown, handleMouseUp, handleMouseLeave]
  },
  // 元素解绑时触发，移除事件监听
  unbind(el) {
    const [handleMouseDown, handleMouseUp, handleMouseLeave] = el.__singleClickHandlers || []
    el.removeEventListener('mousedown', handleMouseDown)
    el.removeEventListener('mouseup', handleMouseUp)
    el.removeEventListener('mouseleave', handleMouseLeave)
    // 清除缓存的处理函数
    delete el.__singleClickHandlers
  }
})
